import { useNavigate, useParams } from "react-router-dom";
import useValidateTab from "./useValidateTab";
import AppPageHeader from "../../../components/Headers/AppPageHeader";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import NotificationsPage from "./NotificationsPage";
import ConversationsPage from "./ConversationsPage";

const NotificationTabs = [
  { title: "My Notifications", activeValue: "notifications" },
  { title: "My Conversations", activeValue: "conversations" },
];

const TabValues = NotificationTabs.map((t) => t.activeValue);

export default function NotificationsHome() {
  const { tab, tenantID } = useParams();
  const navigate = useNavigate();

  useValidateTab(tab as string, TabValues);

  let Page = null;

  if (tab === "notifications") Page = <NotificationsPage />;
  if (tab === "conversations") Page = <ConversationsPage />;

  return (
    <div className="pt-2 px-3 px-md-4">
      <AppPageHeader
        title="Notifications"
        description="View & manage all of your notifications"
      />
      <AppNavbar
        tabs={NotificationTabs}
        activeTab={tab}
        onSelect={(newTab: string) =>
          navigate(`/clouds/${tenantID}/user/${newTab}`)
        }
      />
      <main className="mt-3">{Page}</main>
    </div>
  );
}
